import { useState } from 'react';
import { Sparkles, X } from 'lucide-react';
import { LATEST } from '../changelog';
import { compareVersions, SEEN_KEY } from '../lib/version';
import { fmtDate } from '../lib/utils';

const readSeen = () => {
  try {
    return localStorage.getItem(SEEN_KEY) || '';
  } catch {
    return '';
  }
};

/* Release notes for the newest version, shown until the device dismisses
   them. `force` reopens them from the account menu. */
export default function WhatsNew({ force = false, onClose }) {
  const [seen, setSeen] = useState(readSeen);
  if (!LATEST) return null;
  if (!force && compareVersions(LATEST.version, seen) <= 0) return null;
  const dismiss = () => {
    try {
      localStorage.setItem(SEEN_KEY, LATEST.version);
    } catch {
      /* storage unavailable: shown again next time, harmless */
    }
    setSeen(LATEST.version);
    onClose?.();
  };
  return (
    <section className="mt-3 rounded-xl border border-line bg-surface px-3 py-3" aria-label="What is new">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="flex items-center gap-1.5 text-[15px] font-semibold">
            <Sparkles className="h-4 w-4 text-out" /> New in Inny {LATEST.version}
          </p>
          <p className="mt-0.5 text-[12px] text-ink2">
            {LATEST.title} · {fmtDate(LATEST.date)}
          </p>
        </div>
        <button type="button" onClick={dismiss} aria-label="Close" className="-mr-2 -mt-1 flex h-9 w-9 shrink-0 items-center justify-center rounded-full active:bg-sunken">
          <X className="h-5 w-5" />
        </button>
      </div>
      <ul className="mt-2 space-y-1.5 text-[13px] leading-snug">
        {LATEST.notes.map((n) => (
          <li key={n} className="flex gap-2">
            <span className="mt-[7px] h-1.5 w-1.5 shrink-0 rounded-full bg-out" aria-hidden="true" />
            <span>{n}</span>
          </li>
        ))}
      </ul>
      <button type="button" onClick={dismiss} className="mt-3 w-full rounded-xl bg-ink py-2.5 text-[14px] font-semibold text-bg active:opacity-80">
        Got it
      </button>
    </section>
  );
}
